import { Badge, Card, Group, Stack, Text, Title } from '@mantine/core';
import {
  useContractors,
  useLookup,
  useYukleniciEvraklari,
  useYukleniciPersoneli,
} from '../api/queries';
import { EvrakTablosu, SahaGirisiNedenleri, SahaGirisiRozeti } from './evrak-parts';
import { PortalYolPlani } from './evrak-paketi-parts';
import { BosListeNotu, QueryStatus } from './parts';
import type { ContractorDetail } from '@isg/shared-types';

/**
 * Portal — firma sayfası (F1.5·S12, Kapsam §18.2; **TUR 6 / P1**): temsilci
 * KENDİ firmasının evrakını görür (durum · gerekçe · sürüm · dosya) ve
 * YÜKLER (K5 — §18.2/5 üçüncü istisna). Karar ucu kapalı: `yetkiler.
 * kararVerebilir` sunucudan false gelir, düğme çizilmez. Saha girişi rozeti
 * ve nedenleri SUNUCUDAN (Ş2 — kolon yok). Kişi bazlı evrak kendi
 * personeline bağlanır (kişi seçici firmanın aktif personelinden).
 */
export function PortalFirmaScreen(): React.JSX.Element {
  const contractors = useContractors();
  return (
    <Stack>
      <Title order={3}>Firmam</Title>
      <QueryStatus queries={[contractors]} />
      {contractors.data?.length === 0 && (
        <BosListeNotu mesaj="Hesabınıza bağlı firma bulunamadı — ana firma İSG yetkilinize başvurun." />
      )}
      {contractors.data?.map((contractor) => (
        <PortalFirmaKarti key={contractor.id} firma={contractor} />
      ))}
    </Stack>
  );
}

function PortalFirmaKarti({ firma }: { firma: ContractorDetail }): React.JSX.Element {
  const evraklar = useYukleniciEvraklari(firma.id);
  const personel = useYukleniciPersoneli(firma.id);
  const evrakTipleri = useLookup('evrak_tipi');
  return (
    <Card withBorder padding="md" data-testid="portal-firma-karti">
      <Group justify="space-between" mb="xs">
        <Text fw={600}>{firma.ad}</Text>
        <Group gap="xs">
          {firma.degerlendirmeSkoru !== null && (
            <Badge variant="light">Skor: {firma.degerlendirmeSkoru}/100</Badge>
          )}
          <SahaGirisiRozeti sahaGirisi={firma.sahaGirisi} />
        </Group>
      </Group>
      <SahaGirisiNedenleri sahaGirisi={firma.sahaGirisi} />
      {/* K-102f — ne yüklemeliyim: paket ∪ ek kalemleri durumlarıyla (kart ile AYNI uç). */}
      <PortalYolPlani contractorId={firma.id} />
      <QueryStatus queries={[evraklar, evrakTipleri]} />
      {evraklar.data && (
        <EvrakTablosu
          contractorId={firma.id}
          documents={evraklar.data}
          evrakTipleri={evrakTipleri.data}
          personel={personel.data}
          yukleyebilir={firma.yetkiler.evrakYukleyebilir}
          portal
        />
      )}
      {evraklar.data?.length === 0 && (
        <Text size="sm" c="dimmed" data-testid="portal-evrak-yok">
          Kayıtlı evrak yok.
        </Text>
      )}
    </Card>
  );
}
